export default "__VITE_ASSET__D88xE2TC__"